import React, { Component } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Input,
  Modal,
  UncontrolledTooltip,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import EmptyState from '../../../commons/EmptyState';
import EmptyTypes from '../../../commons/EmptyTypes';
import SvgViewer from '../../../commons/SvgViewer';
import { ProgressButton } from '../../../commons/ProgressButton';
import Services from './Services';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';
import JegyeladasFizetesButton from './JegyeladasFizetesButton';
import Loader from '../../../commons/loader';
import NumberFormatter from '../../../commons/NumberFormatter';
import { flushSync } from 'react-dom';
import _ from 'lodash';

const CONSTANTS = {
  fizetesiModAzonositok: ['KP', 'UTA', 'PPOS'],
  fizetesiModSzinkodok: { KP: ['#ffeb0b', '#d7c900'], UTA: ['#ff710b', '#ce5600'], PPOS: ['#ffae0b', '#c48400'] }
};

const SORT_PATTERN = /\d+/g;

let navigate = undefined;

class JegyeladasContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // [1,2,3,4]
      bucket: [],
      virtualBucket: [],
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      pageStatus: 'LOAD',
      // ['CANCELED', 'SUCCEEDED']
      redirectStatus: ['SUCCEEDED'],
      currentStep: 1,
      isRendeles: false,
      buttonLoading: false,
      foglalasButtonLoading: false,
      fizetesButtonLoading: false,
      fizetesNyomtatasNelkulButtonLoading: false,
      visszatorlesButtonLoading: false,
      kedvezmenyButtonLoading: false,
      isOsszegzesNezet: false,
      selectedTickets: [],
      kedvezmenyList: [],
      activeKedvezmeny: {
        azonosito: null,
        ertek: null,
        ervenyes: false,
        id: null,
        nev: null,
        szazalek: null,
      },
      currentAreaId: null,
      currentSeatId: null,
      currentDiscountId: null,
      bucketPrice: 0,
      formVasarloiKartyaByAidOrSid: {},
      formKedvezmenyListByJegyTipus: {},
      formKedvezmenyValueBySid: {},
      formAlanyMap: {},
      formNev: '',
      formEmail: '',
      formBizonylatszam: '',
      formMegjegyzes: '',
      formRot: '',
      formMegvasarlas: false,
      formFoglalas: false,
      formCurrentPayment: null,
      formBarion: false,
      isControlActive: false,
      isFoglalasModalOpen: false,
      formFizetesiMod: null,
      aktivRendeles: null,
      foglalasButtonLoading: false,
      event: {
        eru: '',
        ecu: '',
        cid: undefined,
        des: undefined,
        eid: undefined,
        end: undefined,
        lid: undefined,
        nam: undefined,
        res: undefined,
        sta: undefined,
        otl: undefined,
      },
      layout: {
        areas: [],
        blocks: [],
        cod: undefined,
        hid: undefined,
        hna: undefined,
        lid: undefined,
        nam: undefined,
        str: {},
        texts: [],
        vad: undefined,
        vna: undefined
      },
      init: {
        sectors: [],
        now: '',
        rot: [],
        pty: []
      },
      rot: {
        name: null
      },
      tickets: [],
      rendeles: {
        gatewayUrl: '',
        rendeles: {},
        rendelesadat: {
          jegyadatok: []
        }
      },
      currency: '',
      loc: undefined,
      navigate: undefined,
      prevProps: undefined,
      rendelesSnapshot: [],
      aktivRendelesLoading: false,
      aktivRendelesId: null,
      ron: null,
      originalQuantityMap: new Map(),
      areaIdsInOrder: [],
      seatIdsInOrder: [],
    };
  }

  onKeyDown = (e) => {
    if (e.key === 'Control' && e.key !== 'AltGraph') {
      this.setState({
        isControlActive: true
      });
    }
  }

  onKeyUp = (e) => {
    if (e.key === 'Control' && e.key !== 'AltGraph') {
      this.setState({
        isControlActive: false
      })
    }
  }

  deleteOrder = (event) => {
    if (this.state.foglalasButtonLoading) return;

    event.preventDefault();
    event.returnValue = '';
    if (this.state.event.rid) {
      Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, true, (err, res) => {
        if (!err) {
        }
      });
    } else {
      Services.wsSend('/kulsomonitor',this.state.eszkozazonosito, (err, res) => {
        if (!err) {
          this.goBack();
        }
      });
    }
  }

  componentDidMount() {
    const rendelesId = window.location.search ? (new URLSearchParams(window.location.search)).get('rendelesId') : null;

    if (this.props && this.props.rendelesId) {
      this.setState({
        isRendeles: true,
        isOsszegzesNezet: true
      });
      this.loadPayData();
    } else {
      this.loadData(rendelesId);
    }

    window.addEventListener('keydown', this.onKeyDown, true);
    window.addEventListener('keyup', this.onKeyUp, true);
    window.addEventListener('beforeunload', e => this.deleteOrder(e), false);
    window.addEventListener('popstate', e => this.deleteOrder(e), false);

    document.body.classList.add("sidebar-hidden");
  }

  loadRendeles = (rendelesId) => {
    this.setState({ aktivRendelesLoading: true }, () => {
      let rendelesSnapshot = [];
      let jegyekToroltNelkul = [];
      Services.getRendeles(rendelesId, (err, res) => {
        if (!err) {
          var eszkozazonosito = null;
          if (localStorage && localStorage.eszkozazonosito && localStorage.eszkozazonosito !== null) {
            eszkozazonosito = localStorage.getItem("eszkozazonosito");
          }

          rendelesSnapshot = res[0].jegyadatok.filter(jegyek => jegyek.jegyAllapot !== "Törölt").map(jegy => ({ id: jegy.id, jegyTipus: jegy.jegyTipus, jegyAllapot: jegy.jegyAllapot }) );
          jegyekToroltNelkul = res[0].jegyadatok.filter(jegyek => jegyek.jegyAllapot !== "Törölt");
          res[0].jegyadatok = jegyekToroltNelkul;

          let originalQuantityMap = new Map();
          for (let item of res[0].jegyadatok.filter(x => !!x.teruletId)) {
            let key = this.getCompoundId(item.teruletId, item.szektorId, item.jegyTipusId);
            originalQuantityMap.set(key, (originalQuantityMap.get(key) || 0) + 1);
          }

          let layout = JSON.parse(JSON.stringify(this.state.layout));
          if (layout.areas && layout.areas.length) {
            layout.areas.forEach(a => {
              let allapot = jegyekToroltNelkul.some(j => j.teruletId === a.tid);
              a.new = allapot;
              a.inorder = allapot;
              a.vanmeg = false;
            });
            this.setState({ layout: layout });
          }

          let initAkt = this.state.init;
          initAkt.sectors = initAkt.sectors.map(m => ({ ...m, vcaf: m.caf }));

          this.setState({
            eszkozazonosito: eszkozazonosito,
            init: initAkt,
            currency: res[0].rendelesOsszegPenznem,
            rendelesSnapshot,
            aktivRendeles: res[0],
            aktivRendelesLoading: false,
            aktivRendelesId: rendelesId,
            ron: res[0].rendelesSorszam,
            originalQuantityMap: originalQuantityMap,
            areaIdsInOrder: [new Set(jegyekToroltNelkul.filter(x => x.id && x.teruletId && x.jegyTipusId).map(x => this.getCompoundId(x.teruletId)))],
            seatIdsInOrder: [new Set(jegyekToroltNelkul.filter(x => x.id && x.szekId && x.jegyTipusId).map(x => this.getCompoundId(x.szekId)))],
            bucket: [],
          });
          document.body.classList.add("sidebar-hidden");
        }
      });
    })
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown, true);
    window.removeEventListener('keyup', this.onKeyUp, true);
    window.removeEventListener("beforeunload", (e) => this.deleteOrder(e), false);
    window.removeEventListener("popstate", (e) => this.deleteOrder(e), false);
  }

  toggleFoglalasModal = () => {
    if (!this.state.isFoglalasModalOpen) {
      window.removeEventListener('keydown', this.onKeyDown, true);
      window.removeEventListener('keyup', this.onKeyUp, true);
      this.setState({
        isControlActive: false
      })
    } else {
      window.addEventListener('keydown', this.onKeyDown, true);
      window.addEventListener('keyup', this.onKeyUp, true);
    }
    this.setState(prevState => ({ isFoglalasModalOpen: !prevState.isFoglalasModalOpen }));
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleVasarloiKartyaChange = (id, item, index) => {
    let helyId = this.getCompoundId(item.aid, item.sid, index);
    let idn = item.idn;
    if (id) {
      Services.listKedvezmenyByJegytipusAndVasarloiKartya(idn, id, (err, res) => {
        if (!err) {
          this.setState((prevState) => {
            let { formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid } = prevState;
            if (res[0].jegy && res[0].jegy[idn]) {
              res[0].jegy[idn].sort((a, b) => a.nev.localeCompare(b.nev));
            }
            formKedvezmenyListByJegyTipus[helyId] = res[0].jegy;
            if (res[0].jegy && res[0].jegy[idn] && res[0].jegy[idn].length == 1) {
              let id = res[0].jegy[idn][0].id;
              formKedvezmenyValueBySid[helyId] = id;
              this.handleKedvezmenyChange(id, item, index)
            } else {
              formKedvezmenyValueBySid[helyId] = null;
            }
          return {
            formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid
          }});
        }
      });
    } else {
      this.setState((prevState) => {
        let { formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid } = prevState;
        formKedvezmenyListByJegyTipus[helyId] = null;
        formKedvezmenyValueBySid[helyId] = null;
        this.handleKedvezmenyChange(null, item, index);
        return {
          formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid
        }
      });
    }
  }

  handleKedvezmenyInputChange = (e, sid, item) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const bucket = JSON.parse(JSON.stringify(this.state.bucket));
    let newBucket = [];

    bucket.forEach((bucketItem) => {
      if (bucketItem.sid === sid) {
        bucketItem.did = value;
      }
      newBucket.push(bucketItem);
    });

    this.setState({
      bucket: newBucket
    });
  }

  getTicketTypeByTicketId = (ticketSector, areaId) => {
    let tickets = JSON.parse(JSON.stringify(this.state.tickets));
    let result = -1;

    tickets.forEach((ticket) => {
      if ((ticket.sec === ticketSector)) {
        result = {
          sec: ticketSector,
          pri: ticket.pri,
          nam: ticket.nam,
          idn: ticket.idn,
          cur: ticket.cur
        };
      }
    });

    return result;
  }

  isTicketInBucket = (tid, deletedTickets) => {
    let hasTalalat = false;
    deletedTickets.forEach((element) => {
      if (tid === element.tid) hasTalalat = true;
    });

    return hasTalalat;
  }

  hasNewSeat = () => {
    let hasNew = false;

    let layout = JSON.parse(JSON.stringify(this.state.layout));
    layout.blocks.forEach((block, idx) => {
      block.seats.forEach(seat => {
        if (seat.new) hasNew = true;
      });
    });
    return hasNew;
  }

  isRendelesEdited = () => {
    let result = false;

    if (this.state.aktivRendeles) {
      let aktivRendelesCopy = JSON.parse(JSON.stringify(this.state.aktivRendeles.jegyadatok));
      let rendelesSnapshotCopy = JSON.parse(JSON.stringify(this.state.rendelesSnapshot));

      if (aktivRendelesCopy.length !== rendelesSnapshotCopy.length) {
        result = true;
      }

      aktivRendelesCopy.forEach(aktiv => {
        rendelesSnapshotCopy.forEach(snap => {
          if (aktiv.id == snap.id) {
            if (aktiv.jegyTipus != snap.jegyTipus) {
              result = true;
            }
          }
        });
      });
    }

    return result;
  }

  zeroPadding = (item) => item.replace(SORT_PATTERN, m => m.padStart(10, '0'));

  buildKey = (item) => this.emptyFormatter(item.rowLabel) + '|' + this.emptyFormatter(item.lsp) + '|' + this.emptyFormatter(item.lab) + '|' + this.emptyFormatter(item.lss) + '|' + this.emptyFormatter(item.ttn);

  sortBucket = (bucket) => {
    if (!bucket) {
      return bucket;
    }

    return bucket.sort((a, b) => this.zeroPadding(this.buildKey(a)).localeCompare(this.zeroPadding(this.buildKey(b))));
  }

  onAreaClick = (ticket) => {
    //ha adott szektor + területen belül minden lehtséges jegy benne van a bucketben, akkor nincs buckethez adás
    let ticketTypeInBucketCount = new Set(this.state.aktivRendeles ?
      this.state.aktivRendeles.jegyadatok.filter(x => ticket.sec === x.szektorId && x.jegyTipusId && ticket.tid === x.teruletId).map(x => x.jegyTipusId) :
      this.state.bucket.filter(x => ticket.sec === x.tid && x.ttid && ticket.tid === x.aid).map(x => x.ttid));

    let ticketTypeCount = this.state.tickets.filter(x => x.sec === ticket.sec);

    //ha az adott szektor + területen belüli jegyek száma már egyenlő a szabad helyekkel, akkor nincs buckethez adás
    //ha a caf = 0, akkor nem lehet már hozzáadni
    let sector = this.state.init.sectors.find(x => x.aid === ticket.tid && x.id === ticket.sec);

    if (ticketTypeInBucketCount.size === ticketTypeCount.length || sector.vcaf === 0) {
      return;
    }

    let layout = JSON.parse(JSON.stringify(this.state.layout));
    if (this.state.aktivRendeles && !this.state.aktivRendeles?.jegyadatok?.some(x => x.teruletId === ticket.tid)) {
      layout.areas = layout.areas.map(a => {
        a.new = this.state.aktivRendeles ? a.new : a.tid === ticket.tid;
        a.vanmeg = this.state.aktivRendeles ? a.vanmeg : false;
        a.inorder = this.state.aktivRendeles ? a.inorder : false;

        return a;
      });

      this.setState({ layout: layout });
    }

    let isDelete = false;
    let addToBucket = !this.state.aktivRendeles || this.state.bucket.length > 0;
    let setBlockSeats = false;

    layout.areas = layout.areas.map(area => {
      if (area.tid === ticket.tid) {
        area.new = true;
        area.inorder =  this.state.aktivRendeles?.jegyadatok?.some(j => j.teruletId === area.tid && j.id) ?? false;
        area.vanmeg = this.state.aktivRendeles?.jegyadatok?.filter(j => j.teruletId === area.tid).length > this.state.aktivRendeles?.jegyadatok?.filter(j => j.teruletId === area.tid && j.id).length;

        if ((this.state.aktivRendeles && ((this.state.aktivRendeles.rendelesAllapot !== "Lefoglalt") && (this.state.aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
          if (this.state.aktivRendeles.rendelesAllapot === "Sikeres fizetés" || this.state.aktivRendeles.rendelesAllapot === "Jegy(ek) átadva" || this.state.aktivRendeles.rendelesAllapot === "Vásárlás részben törölve (Sikeres vásárlás utáni)") {
            addToBucket = true;
            setBlockSeats = true;
            this.setState({
              layout: layout,
              ron: null,
              aktivRendeles: null,
              aktivRendelesLoading: false,
              aktivRendelesId: null,
            });
          }
        }
      } else {
        if ((this.state.aktivRendeles && ((this.state.aktivRendeles.rendelesAllapot !== "Lefoglalt") && (this.state.aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
          if (this.state.aktivRendeles.rendelesAllapot === "Sikeres fizetés" || this.state.aktivRendeles.rendelesAllapot === "Jegy(ek) átadva" || this.state.aktivRendeles.rendelesAllapot === "Vásárlás részben törölve (Sikeres vásárlás utáni)") {
            area.new = false;
            area.inorder = false;
            area.vanmeg = false;
            } else {
              area.vanmeg = this.state.aktivRendeles?.jegyadatok?.filter(j => j.teruletId === area.tid).length > this.state.aktivRendeles?.jegyadatok?.filter(j => j.teruletId === area.tid && j.id).length;
          }
        }
      }

      return area;
    });

    if (setBlockSeats) {
      layout.blocks = layout.blocks.map(b => ({ ...b, seats: b.seats.map(s => ({ ...s, new: false })) }));
    }

    this.setState({ layout: layout });

    if (isDelete) {
      this.setState(prevState => ({
        bucket: prevState.bucket.filter(bucketItem => bucketItem.aid !== ticket.tid),
        layout: layout,
      }), () => {
        this.props.changePortalData(this.state.layout, this.state.init, this.state.event)
      });
    } else {
          let activeTicket = this.getTicketTypeByTicketId(ticket.sec, ticket.tid);

          // kijelölés, buckethez adás csak akkor, ha még a terület+szektor+jegytípus nincs a bucketben
      if (addToBucket) {
        if (!this.state.bucket.some(x => x.aid === ticket.tid && x.tid === ticket.sec && x.ttid === ticket.ttid)) {
          let b = this.state.bucket;
          b.forEach(x => x.selected = false);
          this.setState({ bucket: b });

          this.setSectorVirtualCafArea(ticket.tid, activeTicket.sec, 1);

          this.setState(prevState => ({
            bucket: [...prevState.bucket,
              {
                aid: ticket.tid,
                lab: ticket.lab,
                tid: activeTicket.sec,
                nam: activeTicket.nam,
                cur: activeTicket.cur,
                qua: 1,
                selected: true,
              }
            ],
            layout: layout,
          }), () => {
            this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
          });
        }
      }
    }

    if (!addToBucket) {
      if (!this.state.aktivRendeles.jegyadatok.some(x => x.teruletId === ticket.tid && x.szektorId === ticket.sec && x.jegyTipusId === ticket.ttid)) {
      this.setSectorVirtualCafArea(ticket.tid, ticket.sec, 1);
      this.setState(prev => ({
        layout: layout,
        aktivRendeles: {
          ...prev.aktivRendeles,
          jegyadatok: isDelete
            ? prev.aktivRendeles.jegyadatok.filter(t => ticket.aid !== t.teruletId)
            : [
              ...prev.aktivRendeles.jegyadatok.map(t => ({ ...t, selected: false })),
              ...[{
                "teruletId": ticket.tid,
                "szektorId": this.getTicketTypeByTicketId(ticket.sec).sec,
                "jegyHely": ticket.lab,
                "jegyTipus": this.getTicketTypeByTicketId(ticket.sec).nam,
                "jegyTipus": this.getTicketTypeByTicketId(ticket.sec).nam,
                "jegyPenznem": this.getTicketTypeByTicketId(ticket.sec).cur,
                "jegyAllapot": "Létrehozott",
                "selected": true,
              }]
            ],
          }
        }), () => {
          layout.areas = layout.areas.map(a => ({...a, vanmeg: this.state.aktivRendeles?.jegyadatok?.filter(j => j.teruletId === a.tid).length > this.state.aktivRendeles?.jegyadatok?.filter(j => j.teruletId === a.tid && j.id).length }));
          this.setState({ layout: layout});
        });
      }
    }
  }

  onSeatClick = (ticket, hasGroup, rowLabel, seatPrefix, seatSuffix, blockPrefix) => {
    let addToBucket = !this.state.aktivRendeles || this.state.bucket.length > 0;
    if ('rid' in ticket && ticket['rid']) {
      if ((!this.hasNewSeat()) && (!this.isRendelesEdited())) {
          this.loadRendeles(ticket.rid);
          this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
      } else {
        if (this.hasNewSeat() || this.isRendelesEdited()) {
          if (this.state.aktivRendeles) this.props.globals.addWarning('Módosult a rendelés!');
        }
      }

      return;
    } else if (this.state.aktivRendeles) {
      if (this.state.aktivRendeles.rendelesAllapot === "Sikeres fizetés" || this.state.aktivRendeles.rendelesAllapot === "Jegy(ek) átadva" || this.state.aktivRendeles.rendelesAllapot === "Vásárlás részben törölve (Sikeres vásárlás utáni)") {
        addToBucket = true;
      }
    }

    let isDelete = false;
    let blockIdx = 0;
    let layout = JSON.parse(JSON.stringify(this.state.layout));
    let areas = layout.areas;

    layout.blocks.forEach((block, idx) => {
      block.seats.forEach(seat => {
        if (seat.tid === ticket.tid) {
          if (seat.new) isDelete = true;
          blockIdx = idx;
          if (!seat.new && (this.state.aktivRendeles && ((this.state.aktivRendeles.rendelesAllapot !== "Lefoglalt") && (this.state.aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
            if (this.state.aktivRendeles.rendelesAllapot === "Sikeres fizetés" || this.state.aktivRendeles.rendelesAllapot === "Jegy(ek) átadva" || this.state.aktivRendeles.rendelesAllapot === "Vásárlás részben törölve (Sikeres vásárlás utáni)") {
              areas = areas.map(x => ({ ...x, new: false, inorder: false }));
              layout.areas = areas;
              this.setState({
                layout: layout,
                ron: null,
                aktivRendeles: null,
                aktivRendelesLoading: false,
                aktivRendelesId: null,
                }, () => {
                  addToBucket = true;
              });
              seat.new = true;
            } 
          } else {
            seat.new = !seat.new;
          }
        }
      });
    });
    if (hasGroup || this.state.isControlActive) {
      layout.blocks[blockIdx].seats.forEach(element => {
        if (isDelete) {
          if (!element.col[1]) {
            element.new = false;
          }
        } else {
          if (!element.col[1]) {
            element.new = true;
          }
        }
      });
    }

    if (isDelete) {
      if (hasGroup || this.state.isControlActive) {
        let deletedTickets = [];
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              deletedTickets = block.seats;
            }
          });
        });
        if (addToBucket) {
          let bucket = JSON.parse(JSON.stringify(this.state.bucket));
          let filteredBucket = bucket.filter((item) => {
            return !this.isTicketInBucket(item.sid, deletedTickets);
          });
          this.setState(prevState => ({
            bucket: filteredBucket,
            layout: layout
          }), () => {
            this.setSectorVirtualCafSeat(ticket.sec);
            this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
          });
        } else {
          let jegyadatok = JSON.parse(JSON.stringify(this.state.aktivRendeles.jegyadatok));
          let filtered = jegyadatok.filter(item => !this.isTicketInBucket(item.szekId, deletedTickets));
          this.setState(prev => ({
            aktivRendeles: {
              ...prev.aktivRendeles,
              jegyadatok: filtered,
            }
          }), () => {
            this.setSectorVirtualCafSeat(ticket.sec);
            this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
          });
        }
      } else {
        if (addToBucket) {
          this.setState(prevState => ({
            bucket: prevState.bucket.filter(bucketItem => bucketItem.sid !== ticket.tid),
            layout: layout,
          }), () => {
            this.setSectorVirtualCafSeat(ticket.sec);
            this.props.changePortalData(this.state.layout, this.state.init, this.state.event)
          });
        } else {
          let jegyadatok = JSON.parse(JSON.stringify(this.state.aktivRendeles.jegyadatok));
          let filtered = jegyadatok.filter(item => item.szekId !== ticket.tid);
          this.setState(prev => ({
            aktivRendeles: {
              ...prev.aktivRendeles,
              jegyadatok: filtered,
              layout: layout,
            }
          }), () => {
            this.setSectorVirtualCafSeat(ticket.sec);
            this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
          });
        }
      }
    } else {
      if (hasGroup || this.state.isControlActive) {
        let newTickets = [];
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              newTickets = block.seats.filter(s => !this.state.bucket.map(b => b.sid).includes(s.tid));
            }
          });
        });
        let newDetailedTickets = [];
        newTickets.forEach((item) => {
          if (!item.col[1]) {
            newDetailedTickets.push({
              rowLabel: rowLabel,
              lab: item.lab,
              lbp: blockPrefix,
              lss: seatSuffix,
              lsp: seatPrefix,
              sid: item.tid,
              tid: this.getTicketTypeByTicketId(item.sec).sec,
              selected: true,
            })
          }
        })

        this.setState(prevState => ({
          bucket: !addToBucket ? prevState.bucket : prevState.bucket.concat(newDetailedTickets),
          layout: layout
        }), () => {
          this.setSectorVirtualCafSeat(ticket.sec);
          this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
        });
      } else {
        let b = this.state.bucket;
        b.forEach(x => x.selected = false);
        this.setState({ bucket: b }, () => this.setSectorVirtualCafSeat(ticket.sec));

        this.setState(prevState => ({
          bucket: !addToBucket ? prevState.bucket : [...prevState.bucket,
            {
              rowLabel: rowLabel,
              lab: ticket.lab,
              lbp: blockPrefix,
              lss: seatSuffix,
              lsp: seatPrefix,
              sid: ticket.tid,
              tid: this.getTicketTypeByTicketId(ticket.sec).sec,
              selected: true,
            }
          ],
          layout: layout,
        }), () => {
          this.setSectorVirtualCafSeat(ticket.sec);
          this.props.changePortalData(this.state.layout, this.state.init, this.state.event)
        });
      }
    }

    let activeTickets = [];

    if (hasGroup || this.state.isControlActive) {
      if (isDelete) {
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              activeTickets = block.seats;
            }
          });
        });
        activeTickets = activeTickets.filter(x => !('rid' in x));
      } else {
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              activeTickets = block.seats.filter(s => !this.state.bucket.map(b => b.sid).includes(s.tid));
            }
          });
        });

        activeTickets = activeTickets.filter(x => !('rid' in x));
        isDelete = activeTickets.every(x => x.col[1]);

        if (!isDelete) activeTickets = activeTickets.filter(x => !x.col[1]);
      }
    } else {
      if (this.state.aktivRendeles && ((this.state.aktivRendeles.rendelesAllapot !== "Lefoglalt") && (this.state.aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)"))) {

      } else {
        activeTickets = [ticket];
      }
    }

    if (!addToBucket) {
      this.setState(prev => ({
        layout: layout,
        aktivRendeles: {
          ...prev.aktivRendeles,
          jegyadatok: isDelete
            ? prev.aktivRendeles.jegyadatok.filter(t => !activeTickets.map(x => x.sid).includes(t.szekId))
            : [
              ...prev.aktivRendeles.jegyadatok.map(t => ({ ...t, selected: false })),
              ...activeTickets.map(ticket => ({
                "szekId": ticket.tid,
                "szektorId": this.getTicketTypeByTicketId(ticket.sec).sec,
                "jegySor": rowLabel,
                "jegySzek": `${ticket.lab}. szék`,
                "jegyTipus": this.getTicketTypeByTicketId(ticket.sec).nam,
                "jegyTipusId": this.getTicketTypeByTicketId(ticket.sec).tid,
                "jegyPenznem": this.getTicketTypeByTicketId(ticket.sec).cur,
                "jegyAllapot": "Létrehozott",
                "selected": true,
              }))
            ],
        }
      }), () => this.setSectorVirtualCafSeat(ticket.sec));
    }
  }

  getTicketTypeById = (id, tickettypes) => {
    return tickettypes.find(t => t.tid === id) || null;
  }

  getLayoutSeatDataById = (id, blocks) => {
    for (const block of blocks) {
      const seat = block.seats.find(seat => seat.tid === id);
      if (seat) {
        return {
          lbp: block.lbp,
          rowLabel: block.lab,
          lsp: block.lsp,
          lab: seat.lab,
          lss: block.lss,
        };
      }
    }

    return null;
  };

  getLayoutAreaDataById = (id, areas) => {
    const area = areas.find(area => area.tid === id);

    return area
      ? {
          rowLabel: area.lab,
          lab: area.lab,
        }
      : null;
  };

  loadData = (rendelesId) => {
    const {
      eventId,
    } = this.props;
    this.setState({
      pageStatus: 'LOAD',
    }, () => {
      var eszkozazonosito = null;
      if (localStorage && localStorage.eszkozazonosito && localStorage.eszkozazonosito !== null) {
        eszkozazonosito = localStorage.getItem("eszkozazonosito");
      }
      Services.getAdminEvent(eventId,CONSTANTS.fizetesiModAzonositok, eszkozazonosito, (err, res) => {
        if (!err) {
          res[0].init.sectors = res[0].init.sectors.map(m => ({ ...m, vcaf: m.caf }));

          this.setState({
            eszkozazonosito: eszkozazonosito,
            tickets: res[0].tickets,
            event: res[0].event,
            layout: res[0].layout,
            init: res[0].init,
            currency: res[0].event.cur,
            pageStatus: 'DATA'
          }, () =>{
            if (rendelesId) {
              this.loadRendeles(rendelesId);
            }
          });
      };
    });
    });
  }

  loadPayData = () => {
    const {
      rendelesId,
    } = this.props;

    this.setState({
      pageStatus: 'LOAD',
    }, () => {
      Services.getErtekesitesPay(rendelesId, CONSTANTS.fizetesiModAzonositok, (err, res) => {
        if (!err) {
          let event = res[0].event.event;
          event.eid = res[0].order.eid;
          event.rid = res[0].order.rid;
          event.ron = res[0].order.ron;

          let init = res[0].event.init;
          init.now = res[0].order.now;
          let virtualBucket = [];

          res[0].order.areatickets.forEach(ticket => {
            let ticketTypeData = this.getTicketTypeById(ticket.tid, res[0].event.tickets);
            let areaData = this.getLayoutAreaDataById(ticket.aid, res[0].event.layout.areas);

            let bucketItem = {
              rid: ticket.rid,
              id: ticket.id,
              aid: ticket.aid,
              ttid: ticket.tid,
              lab: areaData.lab,

              tid: ticketTypeData.sec,
              pri: ticketTypeData.pri,
              nam: ticketTypeData.nam,
              cur: ticketTypeData.cur,
              qua: ticket.qua,
              vqua: 1,

              idn: ticketTypeData.idn,
              dis: ticketTypeData.dis,
            }

            if (ticket.qua > 0) {
              for (let index = 0; index < bucketItem.qua; index++) {
                let baseItem = JSON.parse(JSON.stringify(bucketItem));
                baseItem.vqua = 1;
                virtualBucket.push(baseItem);
              }
            }
          });

          res[0].order.seattickets.forEach(ticket => {
            let ticketTypeData = this.getTicketTypeById(ticket.tid, res[0].event.tickets);
            let seatData = this.getLayoutSeatDataById(ticket.sid, res[0].event.layout.blocks);
            let sector = res[0].event.init.sectors.find(x => x.id === ticketTypeData.sec && !x.aid);

            virtualBucket.push({
              rid: ticket.rid,
              id: ticket.id,
              // tdi: null,
              sid: ticket.sid,
              ttid: ticket.tid,
              tid: ticketTypeData.sec,
              nam: ticketTypeData.nam,
              cur: ticketTypeData.cur,
              idn: ticketTypeData.idn,
              pri: ticketTypeData.pri,
              dis: ticketTypeData.dis,
              rowLabel: seatData.rowLabel,
              lab: seatData.lab,
              lss: seatData.lss,
              lbp: seatData.lbp,
              lsp: seatData.lsp,
              secnam: sector && sector.nam,
            });
          });

          var eszkozazonosito = null;
          if (localStorage && localStorage.eszkozazonosito && localStorage.eszkozazonosito !== null) {
            eszkozazonosito = localStorage.getItem("eszkozazonosito");
          }

          this.setState({
            virtualBucket: virtualBucket.map((item, index) => ({ ...item, idx: index })), //  kiegészítés sorszámozással
            tickets: res[0].event.tickets,
            event: event,
            layout: res[0].event.layout,
            init: init,
            currency: event.cur,
            formNev: res[0].order.nam,
            formEmail: res[0].order.ema,
            formBizonylatszam: res[0].order.rno,
            formMegjegyzes: res[0].order.not,
            rot: res[0].order.rot,
            ros: res[0].order.ros,
            ron: res[0].order.ron,
            isOsszegzesNezet: true,
            pageStatus: 'DATA',
            eszkozazonosito: eszkozazonosito,
          }, () => {});
        }
      });
    }
    )
  }

  onLogout = () => {
    this.props.globals.logout();
  }

  emptyFormatter = (data) => {
    if (!data || data === '') return '-';
    return data;
  }

  hasSelectedTicket = () => {
    return (this.state.aktivRendeles ? this.state.aktivRendeles.jegyadatok : this.state.bucket).some(item => item.selected);
  }

  isSectorChanged = (areaId, sectorId, seatId, ticketTypeId) => {
    let isSectorChanged = false;
    let array = this.state.aktivRendeles ? this.state.aktivRendeles.jegyadatok : this.state.bucket;

    array.forEach((ticket) => {
      let area = this.state.aktivRendeles ? ticket.teruletId : ticket.aid;
      let sector = this.state.aktivRendeles ? ticket.szektorId : ticket.tid;

      if ((ticket.selected) && this.getCompoundId(area, sector) !== this.getCompoundId(areaId, sectorId)) {
        isSectorChanged=true;
      }
    })

    return isSectorChanged;
  }

  hasElementWithId = (array, aid, sid) => {
    let hasElement = false;
    array.forEach(element => {
      if (element.aid === aid && element.sid === sid) {
        hasElement = true;
      }
    });

    return hasElement;
  }

  isAllTicketSelected = (tickets) => {
    let result = true;

    tickets.forEach(element => {
      if (!element.selected) {
        result = false;
      }
    });

    return result;
  }

  onSectorTicketsSelect = (bucketDOM) => {
    if (((!this.state.aktivRendeles) || (this.state.aktivRendeles && (this.state.aktivRendeles.rendelesAllapot === "Lefoglalt" || this.state.aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
      if (this.state.aktivRendeles) {
        const aktivRendeles = JSON.parse(JSON.stringify(this.state.aktivRendeles));
        const jegyadatok = aktivRendeles.jegyadatok;
        let newJegyadatok = [];

        if (this.isAllTicketSelected(bucketDOM.elements)) {
          jegyadatok.forEach(j => {
            j.selected = false;
            newJegyadatok.push(j);
          })
        } else {
          jegyadatok.forEach(j => {
            j.selected = this.hasElementWithId(bucketDOM.elements, j.teruletId, j.szekId);
            newJegyadatok.push(j);
          });
        }

        aktivRendeles.jegyadatok = newJegyadatok;

        this.setState({ aktivRendeles: aktivRendeles })
        return;
      }

      const bucket = JSON.parse(JSON.stringify(this.state.bucket));
      let newBucket = [];

      if (this.isAllTicketSelected(bucketDOM.elements)) {
        bucket.forEach(bucketItem => {
          bucketItem.selected = false;
          newBucket.push(bucketItem);
        });
      } else {
        bucket.forEach(bucketItem => {
          bucketItem.selected = this.hasElementWithId(bucketDOM.elements, bucketItem.aid, bucketItem.sid);
          newBucket.push(bucketItem);
        });
      }

      this.setState({ bucket: newBucket });
    }
  }

  onTicketDelete = (ticket, bucketItem, offset) => {
    const newLayout = structuredClone(this.state.layout);
    newLayout.blocks && newLayout.blocks.forEach(b => {
      b.seats = b.seats.map(s => s.tid === ticket.sid ? ({ ...s, col: ['008000', false], new: false, rid: undefined }) : s)
    });

    let filteredBucket = this.state.bucket.filter(t => this.getCompoundId(t.aid,t.tid, t.sid, t.ttid) !== this.getCompoundId(ticket.aid, ticket.tid, ticket.sid, ticket.ttid));
    let filteredJegyadatok = this.state.aktivRendeles ? this.state.aktivRendeles.jegyadatok.filter(i =>
      this.getCompoundId(i.teruletId, i.szektorId, i.szekId, i.jegyTipusId) !== this.getCompoundId(ticket.aid, ticket.tid, ticket.sid, ticket.ttid)) : [];

    newLayout.areas = newLayout.areas && newLayout.areas.map(a => a.tid === ticket.aid ?
      ({ ...a,
      new: (this.state.aktivRendeles ? filteredJegyadatok.filter(j => j.teruletId === ticket.aid) : filteredBucket.filter(b => b.aid === ticket.aid)).length > 0,
      inorder: (this.state.aktivRendeles ? filteredJegyadatok.filter(j => j.teruletId === ticket.aid && j.id) : filteredBucket.filter(b => b.aid === ticket.aid)).length > 0,
      vanmeg: new Set((this.state.aktivRendeles 
        ? filteredJegyadatok.filter(j => j.teruletId === ticket.aid && j.id).map(j => j.jegyTipusId)
        : filteredBucket.filter(j => j.aid === ticket.aid).map(j => j.ttid))).size > 1,
      rid: undefined })
      : a);

    if (bucketItem && offset) {
      this.setSectorVirtualCafArea(bucketItem.aid, bucketItem.id, -offset);
    }

    this.setState({
      bucket: filteredBucket,
      layout: newLayout,
      aktivRendeles: this.state.aktivRendeles ? {
        ...this.state.aktivRendeles,
        jegyadatok: filteredJegyadatok,
      } : null,
    });
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete, formTorlesOka: '' }));
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      Services.checkRendelesDelete([cell], (err, res) => {
        if (!err) {
          this.setState({
            hasTorlesOka: res[0].result
          }, () => {
            this.toggleDeleteModal();
          })
        }
      });
    });
  }

  deleteRendeles = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteRendelesFrom(this.state.torlesId, this.emptyOrNull(this.state.formTorlesOka), (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.props.globals.addSuccess('Rendelés törölve!');
        this.props.dismissPortal();
        document.body.classList.remove("sidebar-hidden");
        this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  onRendelesTicketSelect = (areaId, sectorId, seatId, ticketTypeId) => {
    let newJegyadatok = [];
    let isSectorChanged = false;
    let selectedAreaId = -1;
    let selectedSectorId = -1;
    let selectedSeatId = -1;
    let selectedTTId = -1;
    
    let jegyadatok = JSON.parse(JSON.stringify(this.state.aktivRendeles.jegyadatok));
    jegyadatok.forEach((item) => {
      if (item.teruletId === areaId && item.szektorId === sectorId && item.szekId === seatId && item.jegyTipusId === ticketTypeId) {
        if (this.isSectorChanged(item.teruletId, item.szektorId, item.szekId, item.jegyTipusId)) {
          isSectorChanged = true;
          selectedAreaId = item.teruletId;
          selectedSectorId = item.szektorId;
          selectedSeatId = item.szekId;
          selectedTTId = item.jegyTipusId;
        } else {
          item.selected = !item.selected
        }
      }
      newJegyadatok.push(item);
    });

    if (isSectorChanged) {
      newJegyadatok.forEach((bucketItem) => {
        if (bucketItem.teruletId === selectedAreaId && bucketItem.szektorId === selectedSectorId && bucketItem.szekId === selectedSeatId && bucketItem.jegyTipusId === selectedTTId) {
          bucketItem.selected = true;
        } else {
          bucketItem.selected = false;
        }
      });
    }

    this.setState(prev => ({
      aktivRendeles: {
        ...prev.aktivRendeles,
        jegyadatok: newJegyadatok,
      }
    }));
  }

  onTicketSelect = (areaId, sectorId, seatId, ticketTypeId) => {
    let newBucket = [];
    let isSectorChanged = false;
    let selectedAreaId = -1;
    let selectedSectorId = -1;
    let selectedSeatId = -1;
    let selectedTTId = -1;
    
    const bucket = JSON.parse(JSON.stringify(this.state.bucket));
    bucket.forEach((item) => {
      if (item.aid === areaId && item.tid === sectorId && item.sid === seatId && item.ttid === ticketTypeId) {
        if (this.isSectorChanged(item.aid, item.tid, item.sid, item.ttid)) {
          isSectorChanged = true;
          selectedAreaId = item.aid;
          selectedSectorId = item.tid;
          selectedSeatId = item.sid;
          selectedTTId = item.ttid;
        } else {
          item.selected = !item.selected
        }
      }
      newBucket.push(item);
    });

    if (isSectorChanged) {
      newBucket.forEach((bucketItem) => {
        if (bucketItem.aid === selectedAreaId && bucketItem.tid === selectedSectorId && bucketItem.sid === selectedSeatId && bucketItem.ttid === selectedTTId) {
          bucketItem.selected = true;
        } else {
          bucketItem.selected = false;
        }
      });
    }

    this.setState({
      bucket: newBucket
    });
  }

  getCompoundId = (...params) => {
    return params.filter(x => x !== undefined && x !== null).join('|');
  };

  renderBucket = () => {
    const {
      init,
      bucket,
      aktivRendeles,
    } = this.state;

    let bucketDOM = [];

    if (aktivRendeles) {
      init.sectors.forEach((sector) => {
        let elementsBySector = [];

        aktivRendeles.jegyadatok.forEach((ticket, idx) => {
          if ((ticket.szektorId == sector.id && ticket.teruletId === sector.aid && !ticket.szekId) || //terület jegyek
            (ticket.szektorId == sector.id && !sector.aid && !ticket.teruletId  && ticket.szekId)) // szék jegyek
            elementsBySector.push({
            aid: ticket.teruletId,
            lab: ticket.teruletId ? ticket.jegyHely : null,
            rowLabel: ticket.jegySor,
            lss: ticket.jegySzek,
            lbp: null,
            lsp: null,
            tid: ticket.szektorId,
            sid: ticket.szekId,
            pri: ticket.jegyAr,
            cur: ticket.jegyPenznem,
            nam: ticket.jegyTipus,
            selected: ticket.selected ?? false,
            ttid: ticket.jegyTipusId,
            ttn: ticket.jegyTipus,
            qua: 1,
            bucketIndex: idx,
          });
        });

        // állóhelynél az azonos terület+szék+jegytípus rekordokat a mennyiségeket (qua) összegezve merge-eljük
        const merged = Object.values(
          elementsBySector.reduce((acc, item) => {
            const key = this .getCompoundId(item.aid, item.tid, item.sid, item.ttid, item.pri);
            if (!acc[key]) {
              acc[key] = { ...item };
              acc[key].qua = item.qua ? parseInt(item.qua, 10) : 0;
            } else {
              acc[key].qua += item.qua ? parseInt(item.qua, 10) : 0;
            }
            return acc;
          }, {})
        );

        if (merged.length > 0) {
          bucketDOM.push({
            aid: sector.aid,
            name: sector.nam,
            id: sector.id,
            color: sector.col,
            elements: merged,
            caf: sector.caf,
            vcaf: sector.vcaf,
            cap: sector.cap,
          });
        }
      })
    } else {
      init.sectors.forEach((sector) => {
        let elementsBySector = [];

        bucket.forEach((ticket, idx) => {
          if (ticket.tid === sector.id && ticket.aid == sector.aid) elementsBySector.push({
            aid: ticket.aid,
            lab: ticket.lab,
            ttid: ticket.ttid,
            ttn: ticket.ttn,
            rowLabel: ticket.rowLabel,
            lss: ticket.lss,
            lbp: ticket.lbp,
            lsp: ticket.lsp,
            tid: ticket.tid,
            sid: ticket.sid,
            pri: ticket.pri,
            cur: ticket.cur,
            nam: ticket.nam,
            selected: ticket.selected,
            qua: ticket.qua,
            bucketIndex: idx,
          });
        });

        bucketDOM.push({
          aid: sector.aid,
          name: sector.nam,
          id: sector.id,
          color: sector.col,
          elements: elementsBySector,
          caf: sector.caf,
          vcaf: sector.vcaf,
          cap: sector.cap,
        });
      })
    }

    return bucketDOM.map((bucketItem) => {
        return (
          bucketItem.elements.length !== 0 && (
            <React.Fragment>
              <h6>
                <span>{bucketItem.name}</span>
                <React.Fragment>
                  <span>{' (szabad/összes - ' + bucketItem.vcaf + '/' + bucketItem.cap + '): '}</span>
                </React.Fragment>
                <i
                  className="fa fa-check-square-o"
                  aria-hidden="true"
                  style={{ cursor: 'pointer', marginTop: 12, marginLeft: 4 }}
                  onClick={() => this.onSectorTicketsSelect(bucketItem)}
                />
              </h6>
              <div className="row">
                {bucketItem.elements.map((ticket, elementIdx) => {
                  return (
                    <React.Fragment key={elementIdx}>
                      {ticket.sid &&
                        <div className="col-md-12 noselect">
                          <div
                            className='d-flex align-items-center justify-content-between'
                            style={{
                              padding: 7,
                              border: '1px solid #e4e4e4',
                              marginBottom: 6,
                              cursor: ((!aktivRendeles) || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) ? 'pointer' : 'not-allowed',
                              backgroundColor: ticket.selected ? '#ffeabe' : 'white'
                            }}
                            onClick={() => {
                              if (!aktivRendeles || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) {
                                this.state.aktivRendeles ? this.onRendelesTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid) : this.onTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid);
                              }
                            }}
                          >
                            <div onClick={(e) => {
                              e.stopPropagation();
                              if (!aktivRendeles || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) {
                                this.state.aktivRendeles ? this.onRendelesTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid) : this.onTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid);
                              }
                            }}>
                              <b>Hely:</b><span>{' ' + (ticket.lbp ? ticket.lbp : ' ') + ' ' + (ticket.rowLabel || '') + ', ' + (ticket.lsp ? ticket.lsp : '') + ' ' + (ticket.lab || '') + (ticket.lss ? ticket.lss : ' ') }</span>
                              <br />
                              <b>Jegytípus:</b><span>{' ' + (ticket.ttid ? (ticket.ttn + ' | ' + NumberFormatter.formatterSpaceOsszegPenznem(ticket.pri, null,ticket.cur)) : '-')}</span>
                            </div>

                            {((!aktivRendeles) || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) && (
                              <React.Fragment>
                                <Button
                                  className="icon-trash table-action-icon"
                                  id={'ticket-' + elementIdx.toString() + '-torles'}
                                  style={{ fontSize: 16, padding: '4px 6px' }}
                                  onClick={e => {
                                    e.stopPropagation();
                                    this.onTicketDelete(ticket, bucketItem, 1);
                                  }}
                                />
                                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'ticket-' + elementIdx.toString() + '-torles'} delay={0}>Törlés</UncontrolledTooltip>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      }
                      {ticket.aid &&
                        <div className="col-md-12 noselect">
                          <div
                            className='d-flex align-items-center justify-content-between'
                            style={{
                              padding: 7,
                              border: '1px solid #e4e4e4',
                              marginBottom: 6,
                              cursor: (!aktivRendeles || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) ? 'pointer' : 'not-allowed',
                              backgroundColor: ticket.selected ? '#ffeabe' : 'white'
                            }}
                            onClick={() => {
                              if (!aktivRendeles || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) {
                                this.state.aktivRendeles ? this.onRendelesTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid) : this.onTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid);
                              }
                            }}
                          >
                            <div onClick={(e) => {
                              e.stopPropagation();
                              if (!aktivRendeles || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) {
                                this.state.aktivRendeles ? this.onRendelesTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid) : this.onTicketSelect(ticket.aid, ticket.tid, ticket.sid, ticket.ttid);
                              }
                            }}>
                              <b>Hely:</b><span>{' ' + (ticket.rowLabel  ? ticket.rowLabel + ', ' : ' ') + ' ' + (ticket.lab || ' ') }</span>
                              <br />
                              <b>Jegytípus:</b><span>{' ' + (ticket.ttid ? (ticket.ttn + ' | ' + NumberFormatter.formatterSpaceOsszegPenznem(ticket.pri, null, ticket.cur)) : '-')}</span>
                              <br />
                              {(aktivRendeles && aktivRendeles.rendelesAllapot !== "Lefoglalt" && aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)") && (
                                <React.Fragment> <b>Mennyiség:</b><span> {NumberFormatter.formatterSpaceOsszegPenznem(ticket.qua, null, 'db')}</span></React.Fragment>)}
                            </div>

                            {((!aktivRendeles) || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) && (
                              <React.Fragment>
                                <div style={{ display: 'flex'}}>
                                  <Button
                                    id="plus"
                                    type="button"
                                    style={{ marginRight: '10px' }}
                                    className="btn btn-secondary text-correct-button"
                                    disabled={this.state.buttonLoading}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.handleTicketQuantityChange(e, bucketItem, ticket, -1);
                                    }}
                                  >-</Button>
                                  <RFForm id="form-quantity" onSubmit={() => {}} style={{ marginBottom: 0 }}>
                                    <RFField
                                      id="ticketQuantity"
                                      name="ticketQuantity"
                                      style={{ textAlign: 'center', width: '75px', marginBottom: 0 }}
                                      numberOnlyWhole
                                      forcedValue={this.state.bucket && (!aktivRendeles ? this.state.bucket[ticket.bucketIndex].qua : ticket.qua)}
                                      autoComplete="off"
                                      onChange={(e) => this.handleTicketQuantityChange(e, bucketItem, ticket)}
                                      onFocus={(e) => {e.target.select()}}
                                      onClick={(e) => {e.target.select()}}
                                      required
                                        />
                                  </RFForm>
                                  <Button
                                    id="minus"
                                    type="button"
                                    style={{ marginLeft: '10px' }}
                                    className="btn btn-secondary text-correct-button"
                                    disabled={this.state.buttonLoading}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.handleTicketQuantityChange(e, bucketItem, ticket, 1);
                                    }}
                                  >+</Button>
                                  <Button
                                    className="icon-trash table-action-icon"
                                    id={'ticket-' + elementIdx.toString() + '-torles'}
                                    style={{ fontSize: 16, padding: '4px 6px', marginLeft: '10px' }}
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.onTicketDelete(ticket, bucketItem, this.state.bucket && (!aktivRendeles ? this.state.bucket[ticket.bucketIndex].qua : ticket.qua));
                                    }}
                                  />
                                  <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'ticket-' + elementIdx.toString() + '-torles'} delay={0}>Törlés</UncontrolledTooltip>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      }
                    </React.Fragment>
                  )
                })}
              </div>
            </React.Fragment>
          )
        )
    })
  }

  handleTicketQuantityChange = (e, bucketItem, ticket, offset) => {
    const { target } = e;
    let value = target.type === 'checkbox' ? target.checked : target.value;

    const { aktivRendeles, originalQuantityMap, init } = this.state;

    if (!offset && (!Number.isInteger(parseInt(value, 10)) || parseInt(value, 10) <= 0)) {
      value = 1;
    }

    if (!aktivRendeles) {
      let bucket = JSON.parse(JSON.stringify(this.state.bucket));
      let bucketIdx = bucket[ticket.bucketIndex];

      let otherTicketInSectorCount = bucketItem.elements
      .filter(x => this.getCompoundId(x.aid, x.tid, x.ttid) !== this.getCompoundId(ticket.aid, ticket.tid, ticket.ttid))
      .reduce((sum, item) => sum + (item.qua || 0), 0);


      let maxValue = Math.min(bucketItem.caf, bucketItem.caf - otherTicketInSectorCount);
      value = Math.min(Math.max(value, 1), maxValue);

      const originalQua = bucketIdx.qua;

      bucketIdx.qua = Math.min(Math.max(1, offset ? parseInt(bucketIdx.qua, 10) + parseInt(offset, 10) : parseInt(value, 10)), maxValue);
      bucket[ticket.bucketIndex] = bucketIdx;

      this.setSectorVirtualCafArea(bucketItem.aid, bucketItem.id, bucketIdx.qua - originalQua);

      this.setState({ bucket: bucket });
    } else {
      let compoundId = this.getCompoundId(ticket.aid, ticket.tid);
      let originalQuantityInArea = 0;
      for (const [key, value] of originalQuantityMap) {
        if (key.startsWith(compoundId)) {
          originalQuantityInArea += value;
        }
      }

      compoundId = this.getCompoundId(ticket.aid, ticket.tid, ticket.ttid);
      const otherTicketInSectorCount = bucketItem.elements.filter(x => this.getCompoundId(x.aid, x.tid, x.ttid) !== compoundId).reduce((sum, item) => sum + (item.qua || 0), 0);
      const maxValue = bucketItem.caf + originalQuantityInArea - otherTicketInSectorCount;

      value = Math.min(Math.max(value, 1), maxValue);

      let jegyadatok = JSON.parse(JSON.stringify(aktivRendeles.jegyadatok));
      let jegyadat = JSON.parse(JSON.stringify(jegyadatok[ticket.bucketIndex]));
      let count = jegyadatok.filter(x=> x.teruletId === ticket.aid && x.szektorId === ticket.tid && x.jegyTipusId === ticket.ttid).length;

      if (offset > 0) {  // növelés
        if (count < maxValue) {
          jegyadat.id = null;
          jegyadatok.splice(ticket.bucketIndex + 1, 0, jegyadat);
          this.setSectorVirtualCafArea(bucketItem.aid, bucketItem.id, offset);
        }
      } else if (offset < 0) { // csökkentés
        if (count >= 2) { // min 1
          let last = jegyadatok.findLastIndex(x=> x.teruletId === ticket.aid && x.szektorId === ticket.tid && x.jegyTipusId === ticket.ttid);
          jegyadatok.splice(last, 1);
          this.setSectorVirtualCafArea(bucketItem.aid, bucketItem.id, offset);
        }
      } else { // mennyiség mezőbe írás
         if (count < value) {
          jegyadat.id = null;
          for (let i = 0; i < value - count; i++) {
            jegyadatok.splice(ticket.bucketIndex + 1, 0, jegyadat);
            this.setSectorVirtualCafArea(bucketItem.aid, bucketItem.id, value - count);
          }
        } else if (count > value) {
          let lastIndex = jegyadatok.findLastIndex(x=> x.teruletId === ticket.aid && x.szektorId === ticket.tid && x.jegyTipusId === ticket.ttid);
          jegyadatok.splice(lastIndex - (count - value) + 1, count - value);
          this.setSectorVirtualCafArea(bucketItem,aid, bucketItem.id, count - value);
        }
      }
      this.setState({
        aktivRendeles: {
          ...aktivRendeles,
          jegyadatok: jegyadatok,
        },
      });
    }
  }

  // szabad/összes rendezése a szektorban (állóhely)
  setSectorVirtualCafArea = (areaId, sectorId, offset) => {
    let initAkt  = this.state.init;
    let sectorsAkt = initAkt.sectors.map(s => {
      if (s.sid) {
        return m;
      }

      s.vcaf = (s.aid === areaId && s.id === sectorId) ? Math.min(s.vcaf - offset, s.cap) : s.vcaf;

      return s;
    });

    initAkt.sectors = sectorsAkt;
    this.setState({ init: initAkt });
  }

  // szabad/összes rendezése a szektorban (ülőhely)
  setSectorVirtualCafSeat = (sectorId) => {
    let initAkt = this.state.init;
    initAkt.sectors = initAkt.sectors.map(sector => {
      if (sector.aid || (sector.id !== sectorId)) {
        return sector;
      } else if (this.state.aktivRendeles && this.state.aktivRendeles.jegyadatok ) {

        let quantity = this.state.aktivRendeles.jegyadatok.filter(j => !j.id && j.szekId && j.szektorId === sector.id).length;

        return ({ ...sector, vcaf: sector.caf - quantity});
      } else if (!this.state.aktivRendeles) {
        return ({ ...sector, vcaf: sector.caf - this.state.bucket.filter(b => b.sid && b.tid === sector.id).length });
      } else {
        return sector;
      }
    });

    this.setState({ init: initAkt });
  }

  setJegytipusok = (ticketTypeId, ticketTypeName, ticketPrice, ticketDiscount, ticketTypeIdentifier, ticketCurrency) => {
    if (this.state.aktivRendeles) {
      this.setState({
        aktivRendeles: {
          ...this.state.aktivRendeles,
          jegyadatok: this.state.aktivRendeles.jegyadatok.map(item => item.selected ? ({
            ...item,
            id: item.jegyTipusId !== ticketTypeId && item.teruletId ? null : item.id,
            foglalasId: item.jegyTipusId !== ticketTypeId && item.teruletId ? null : item.foglalasId,
            jegyTipusId: item.jegyTipusId !== ticketTypeId ? ticketTypeId : item.jegyTipusId,
            jegyTipus: ticketTypeName,
            jegyAr: ticketPrice,
            jegyPenznem: ticketCurrency,
            jegyKedvezmenyNev: ticketDiscount,
            selected: false
          }) : item)
        },
      });
    } else {
      let newBucket = [];
      
      let bucket = JSON.parse(JSON.stringify(this.state.bucket));
      bucket.forEach((bucketItem) => {
        if (bucketItem.selected) {
          bucketItem.selected = false;
          if (bucketItem.ttid !== ticketTypeId) {
            bucketItem.rid = bucketItem.aid ? null : bucketItem.rid;
            bucketItem.id = bucketItem.aid ? null : bucketItem.id;
            bucketItem.ttid = ticketTypeId;
          }
          bucketItem.ttn = ticketTypeName;
          bucketItem.pri = ticketPrice;
          bucketItem.cur = ticketCurrency;
          bucketItem.dis = ticketDiscount;
          bucketItem.idn = ticketTypeIdentifier;
        }
        newBucket.push(bucketItem);
      });

      // állóhelynél az azonos terület+szék+jegytípus rekordokat a mennyiségeket (qua) összegezve merge-eljük
      const merged = Object.values(
        newBucket.reduce((acc, item) => {
          const key = this .getCompoundId(item.aid, item.tid, item.sid, item.ttid);
          if (!acc[key]) {
            acc[key] = { ...item };
            acc[key].qua = item.qua ? parseInt(item.qua, 10) : 0;
          } else {
            acc[key].qua += item.qua ? parseInt(item.qua, 10) : 0;
          }
          return acc;
        }, {})
      );

      this.setState({
        bucket: merged
      });
    }
  }

  getTicketTypesBySector = (sector) => {
    return this.state.tickets.map(ticket => {
      if (ticket.sec === sector) {
        return <option value={ticket.tid}>{ticket.nam + ' | ' + NumberFormatter.formatterSpaceOsszegPenznem(ticket.pri, null, ticket.cur)}</option>
      }
    })
  }

  getKedvezmenyByJegytipus = (idn, helyId) => {
    let options = [];
    let stateObj = this.state.formKedvezmenyListByJegyTipus[helyId] || {};
    let kedvezmenyList = stateObj[idn];
    if (kedvezmenyList && kedvezmenyList.length > 0) {
      options = [...options, kedvezmenyList.map(kedvezmeny => <option value={kedvezmeny.id}>{kedvezmeny.nev}{' (' + NumberFormatter.formatterSpaceOsszegPenznem(kedvezmeny.mertek, null, ')')}</option>)]
    }

    return options;
  }

  renderJegytipusok = () => {
    let bucketItem = this.state.aktivRendeles ? this.state.aktivRendeles.jegyadatok.find(x => x.selected) : this.state.bucket.find(x => x.selected);
    let szektorjegyek = this.state.tickets.filter(x => x.sec === (this.state.aktivRendeles ? bucketItem.szektorId : bucketItem.tid));
    let jegytipusok = new Set(this.state.aktivRendeles ? this.state.aktivRendeles.jegyadatok.filter(x => x.teruletId && x.jegyTipusId) : this.state.bucket.filter(x => x.aid && x.ttid));
    let jegytipusokToRender = (!bucketItem.aid ? szektorjegyek : szektorjegyek.filter(x => !jegytipusok.has(x.tid))).sort((a, b) => this.zeroPadding(a.nam).localeCompare(this.zeroPadding(b.nam)));

    return jegytipusokToRender.map((ticketType) => {
      return (
        <Card
          className='user-select-none'
          style={{
            padding: 5,
            marginTop: 10,
            marginBottom: 10,
            backgroundColor: '#fff',
            color: '#212529',
            cursor: 'pointer',
            textAlign: 'center',
            borderRadius: '5px',
            boxShadow: '0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%)'
          }}
          onClick={ () => this.setJegytipusok(ticketType.tid, ticketType.nam, ticketType.pri, ticketType.dis, ticketType.idn, ticketType.cur)}
        >
          <CardBody>
            <CardTitle>
              {ticketType.nam}
              {ticketType.pub ? '': <i className="fa fa-lock pull-right" aria-hidden="true" style={{ color: 'red' }} />}
            </CardTitle>
            <CardSubtitle>{NumberFormatter.formatterSpaceOsszegPenznem(ticketType.pri, null,  ticketType.cur)}</CardSubtitle>
          </CardBody>
        </Card>
      );
    });
  }

  handleSubmitType = (name) => {
    this.setState({
      buttonLoading: true
    }, () => {
      let bucket = [];
      let areatickets = [];
      let seattickets = [];

      switch (name) {
        case 'HELYSZINI_FOGLALAS':
          bucket = JSON.parse(JSON.stringify(this.state.bucket));
          areatickets = [];
          seattickets = [];

          bucket.forEach(bucketItem => {
            if (bucketItem.aid) {
              areatickets.push({
                aid: bucketItem.aid,
                tid: bucketItem.ttid,
                qua: bucketItem.qua,
              });
            } else if (bucketItem.sid) {
              seattickets.push({
                sid: bucketItem.sid,
                tid: bucketItem.ttid,
              });
            }
          })

          Services.sendAdminPurchase({
            ste: 1,
            eid: this.state.event.eid,
            now: this.state.init.now,
            rot: name,
            areatickets: areatickets,
            seattickets: seattickets,
            fizmodok: CONSTANTS.fizetesiModAzonositok,
          }, false, this.state.eszkozazonosito, (err, res) => {
            if (!err) {
              let event = JSON.parse(JSON.stringify(this.state.event))
              event.rid = res[0].rendeles.rid;

              bucket.forEach(bucketItem => {
                if (bucketItem.aid) {
                  let area = res[0].rendeles.areatickets.find(x => bucketItem.aid === x.aid && bucketItem.ttid === x.tid);
                  bucketItem.rid = area && area.rid
                  bucketItem.id = area && area.id;
                } else if (bucketItem.sid) {
                  let seat = res[0].rendeles.seattickets.find(x => bucketItem.sid === x.sid && bucketItem.ttid === x.tid);
                  bucketItem.rid = seat && seat.rid;
                  bucketItem.id = seat && seat.id;
                }
              });

              bucket = this.sortBucket(bucket);

              this.setState({
                rot: res[0].rendeles.rot,
                ron: res[0].rendeles.ron,
                event: event,
                bucket: bucket,
                buttonLoading: false
              })
              this.toggleFoglalasModal();
            } else {
              this.setState({ buttonLoading: false });
            }
          });
          break;
        case 'HELYSZINI_VASARLAS':
          bucket = JSON.parse(JSON.stringify(this.state.bucket));
          areatickets = [];
          seattickets = [];

          bucket.forEach(bucketItem => {
            if (bucketItem.aid) {
              areatickets.push({
                aid: bucketItem.aid,
                tid: bucketItem.ttid,
                qua: bucketItem.qua,
              });
            } else if (bucketItem.sid) {
              seattickets.push({
                sid: bucketItem.sid,
                tid: bucketItem.ttid,
              });
            }
          })

          Services.sendAdminPurchase({
            ste: 1,
            eid: this.state.event.eid,
            now: this.state.init.now,
            rot: name,
            areatickets: areatickets,
            seattickets: seattickets,
            fizmodok: CONSTANTS.fizetesiModAzonositok,
          }, false, this.state.eszkozazonosito, (err, res) => {
            if (!err) {
              let event = JSON.parse(JSON.stringify(this.state.event))
              event.rid = res[0].rendeles.rid;

              bucket.forEach(bucketItem => {
                if (bucketItem.aid) {
                  let area = res[0].rendeles.areatickets.find(x => bucketItem.aid === x.aid && bucketItem.ttid === x.tid);
                  bucketItem.rid = area && area.rid
                  bucketItem.id = area && area.id;
                } else if (bucketItem.sid) {
                  let seat = res[0].rendeles.seattickets.find(x => bucketItem.sid === x.sid && bucketItem.ttid === x.tid);
                  bucketItem.rid = seat && seat.rid;
                  bucketItem.id = seat && seat.id;
                }
              })

              bucket = this.sortBucket(bucket);

              // állóhelyeket szét kell szedni a bucketben a jegyenkénti kedvezmény kiválasztásához (majd később megrelni kell, és a kedvezmények List-be kerülek)
              let virtualBucket = [];
              bucket.forEach(item => {
                let sector = this.state.init.sectors.find(x => x.id === item.tid && item.sid !== null && !x.aid);
                item.secnam = sector && sector.nam;

                if (item.aid && item.qua > 0) {
                  for (let index = 0; index < item.qua; index++) {
                    item.vqua = 1;
                    virtualBucket.push(item);
                  }
                } else {
                  virtualBucket.push(item);
                }
              });


              this.setState({
                rot: res[0].rendeles.rot,
                ron: res[0].rendeles.ron,
                event: event,
                bucket: bucket,
                virtualBucket: virtualBucket.map((item, index) => ({ ...item, idx: index })), //  kiegészítés sorszámozással
                isOsszegzesNezet: true,
                buttonLoading: false
              })
            } else {
              this.setState({ buttonLoading: false });
            }
          });
          break;
        default:
          break;
      }
    })
  }

  handlePurchaseFoglalas = () => {
    this.setState({ foglalasButtonLoading: true }, () => {
      const areatickets = [];
      const seattickets = [];

      this.state.aktivRendeles.jegyadatok.forEach(ticket => {
        if (ticket.jegyAllapot === 'Létrehozott') {
          if (ticket.teruletId) {
            const foundArea = this.state.layout.areas.find(x => x.tid === ticket.teruletId);
            if (foundArea) {
              areatickets.push({
                rid: ticket.foglalasId,
                id: ticket.id,
                aid: ticket.teruletId,
                tid: ticket.jegyTipusId || null,
                qua: 1,
              });
            }
          } else if (ticket.szekId) {
            for(const b of this.state.layout.blocks) {
              const foundSeat = b.seats.find(x => x.tid === ticket.szekId);
              if (foundSeat) {
                seattickets.push({
                  rid: ticket.foglalasId,
                  id: ticket.id,
                  sid: ticket.szekId,
                  tid: ticket.jegyTipusId || null,
                });
              }
            }
          }
        }
      });

      Services.sendAdminPurchasePay2({
        ste: 2,
        eid: this.state.event.eid,
        now: this.state.init.now,
        areatickets: areatickets,
        seattickets: seattickets,
        rot: this.state.aktivRendeles.rendelesTipus,
        rid: this.state.aktivRendelesId,
        fizmodok: CONSTANTS.fizetesiModAzonositok,
      }, false, this.state.eszkozazonosito, (err, res) => {
        if (!err) {
          const event = JSON.parse(JSON.stringify(this.state.event));
          event.rid = this.state.aktivRendelesId || res[0].rendeles.rid;

          flushSync(() => {
            this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/test`, { replace: true, relative: 'path' });
          });
          flushSync(() => {
            this.props.globals.route.navigate(
              `${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites/rendeles/${this.state.aktivRendelesId}`,
              { replace: true, relative: 'path' }
            );
          });
        } else {
          this.setState({ foglalasButtonLoading: false });
        }
      });
    });
  }

  onFoglalasVeglegesites = () => {
    this.setState({ foglalasButtonLoading: true }, () => {
      let areatickets = [];
      let seattickets = [];
      
      let bucket = JSON.parse(JSON.stringify(this.state.bucket));
      bucket.forEach(bucketItem => {
        if (bucketItem.aid) {
          areatickets.push({
            rid: bucketItem.rid,
            id: bucketItem.id,
            aid: bucketItem.aid,
            tid: bucketItem.ttid,
            qua: bucketItem.qua,
          });
        } else if (bucketItem.sid) {
          seattickets.push({
            rid: bucketItem.rid,
            id: bucketItem.id,
            sid: bucketItem.sid,
            tid: bucketItem.ttid,
          });
        }
      })

      Services.sendAdminPurchase({
        ste: 2,
        rid: this.state.event.rid,
        eid: this.state.event.eid,
        now: this.state.init.now,
        rot: this.state.rot.name,
        nam: this.state.formNev,
        ema: this.state.formEmail,
        rno: this.state.formBizonylatszam,
        not: this.state.formMegjegyzes,
        areatickets: areatickets,
        seattickets: seattickets,
        fizmodok: CONSTANTS.fizetesiModAzonositok,
      }, false, this.state.eszkozazonosito, (err, res) => {
        if (!err) {
          let event = JSON.parse(JSON.stringify(this.state.event))

          this.setState({
            event: event,
            isFoglalasModalOpen: false,
            foglalasButtonLoading: false
          }, () => {
            this.props.dismissPortal();
            document.body.classList.remove("sidebar-hidden");
            this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
          })
        } else {
          this.setState({ foglalasButtonLoading: false });
        }
      });
    });
  }

  handleJegytipusChange = (e, item, index) => {
    let price = this.getPriceByTicketTypeId(e.target.value)
    let dis = this.getDiscountByTicketTypeId(e.target.value);
    let virtualBucket = JSON.parse(JSON.stringify(this.state.virtualBucket));
    let ticket = this.state.tickets.find(ticket => ticket.tid == e.target.value);

    let bucketItem = virtualBucket[index];
    bucketItem.dis = dis;
    bucketItem.did = '';
    bucketItem.kedvezmeny = null;
    if (bucketItem.ttid !== ticket.tid) {
      bucketItem.rid = bucketItem.aid ? null : bucketItem.rid;
      bucketItem.id = bucketItem.aid ? null : bucketItem.id;
      bucketItem.ttid = ticket.tid;
    }
    bucketItem.pri = price;
    bucketItem.idn = ticket.idn;
    bucketItem.cur = ticket.cur;

    let a = this.state.formVasarloiKartyaByAidOrSid;
    delete a[this.getCompoundId(item.aid, item.sid, index)];

    this.setState({
      virtualBucket: virtualBucket,
      isFoglalasModalOpen: false,
      veglegesitesButtonLoading: false,
      formVasarloiKartyaByAidOrSid: a
    });
  }

  handleKedvezmenyChange = (value, item, index) => {
    let formAlanyMap = {...this.state.formAlanyMap};
    let kedvezmeny = null;
    if (value) {
      let kedvezmenyList = [
        ...this.state.formKedvezmenyListByJegyTipus[this.getCompoundId(item.aid, item.sid, index)][item.idn]
    ];
      kedvezmeny = kedvezmenyList.find(kedvezmeny => kedvezmeny.id == value);
      formAlanyMap[item.id] = kedvezmeny.alanyId;
      this.setState({ formAlanyMap, formAlanyId: kedvezmeny.alanyId });
    } else {
      formAlanyMap[item.id] = undefined;
      this.setState({ formAlanyMap });
    }
    let virtualBucket = [...this.state.virtualBucket];
    virtualBucket.forEach((bucketItem, itemIndex) => {
      if (this.getCompoundId(item.aid, item.sid, index) === this.getCompoundId(bucketItem.aid, bucketItem.sid, itemIndex)) {
        item.kedvezmeny = kedvezmeny;
        item.did = value;
      }
    });
    let formKedvezmenyValueBySid = {...this.state.formKedvezmenyValueBySid};
    formKedvezmenyValueBySid[this.getCompoundId(item.aid, item.sid, index)] = value;
    this.setState({ virtualBucket, formKedvezmenyValueBySid });
  }

  isPaymentActive = (paymentId) => {
    return this.state.formFizetesiMod === paymentId;
  }

  renderPaymentCards = () => {
    return this.state.init.fizmod && this.state.init.fizmod.map((item) => {
      return (
        <Card
          className='user-select-none'
          style={{
            padding: 0,
            marginTop: 10,
            marginBottom: 10,
            marginRight: 10,
            backgroundColor: CONSTANTS.fizetesiModSzinkodok[item.kod][this.isPaymentActive(item.id) ? 1 : 0],
            color: '#212529',
            cursor: 'pointer',
            border: this.isPaymentActive(item.id) ? 'solid gray' : null,
            width: '150px',
            textAlign: 'center',
            borderRadius: '5px',
            boxShadow: '0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%)'
          }}
          onClick={ () => {
            this.setState({
              formFizetesiMod: item.id
            })
          }}
        >
          <CardBody>
            <CardTitle style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', height: '35px', marginBottom: 0 }}>
              {item.nev}
            </CardTitle>
          </CardBody>
        </Card>
      );
    });
  }

  getTotalPrice = (inVirtualBucket) => {
    if (this.state.aktivRendeles) {
      return this.state.aktivRendeles.jegyadatok.reduce((acc, curr) => acc + (curr.jegyAr || 0), 0);
    }

    let price = 0;

    (inVirtualBucket ? this.state.virtualBucket : this.state.bucket).forEach(bucketItem => {
      price += this.getCorrectPrice((bucketItem.pri || 0) * ((inVirtualBucket ? bucketItem.vqua : bucketItem.qua) || 1), bucketItem.kedvezmeny, bucketItem.ttid);
    });

    return price;
  }

  getTotalTicketCount = (inVirtualBucket) => {
    if (this.state.aktivRendeles) {
      return this.state.aktivRendeles.jegyadatok.length;
    }

    if (inVirtualBucket) {
      return this.state.virtualBucket.reduce((acc, curr) => acc + (curr.vqua || 1), 0);
    }

    return this.state.bucket.reduce((acc, curr) => acc + (curr.qua || 1), 0);
  }

  getPriceByTicketTypeId = (id) => {
    let price = 0;
    let ticketTypes = JSON.parse(JSON.stringify(this.state.tickets));

    ticketTypes.forEach(element => {
      if (element.tid === id) {
        price = element.pri
      }
    });

    return price;
  }

  getFixarByTicketTypeId = (id) => {
    let fpr = 0;
    let ticketTypes = JSON.parse(JSON.stringify(this.state.tickets));

    ticketTypes.forEach(element => {
      if (element.tid === id) {
        fpr = element.fpr ? element.fpr : 0
      }
    });

    return fpr;
  }

  getDiscountByTicketTypeId = (id) => {
    let dis = false;
    let ticketTypes = JSON.parse(JSON.stringify(this.state.tickets));

    ticketTypes.forEach(element => {
      if (element.tid === id) {
        dis = element.dis
      }
    });

    return dis;
  }

  loadVasarloiKartyaOptions = (v, item, index) => {
    const helyId = this.getCompoundId(item.aid, item.sid, index);
    // Kérésre a volt listázó csak pontos azonosítókra kell, hogy "listázzon", ezért select helyett egy sima RFField lett alkalmazva,
    // így viszont a select objektum kezelése a formVasarloiKartyaByAidOrSid segítségével van helyettesítve, ami id-t mappel minden sorhoz
    // (a sorok sid alapján vannak azonosítva, a beírt azonosító a keresésen túl haszontalan, ezért van csak az id lementve)
    Services.listVasarloiKartyaAzons(v, true, true, (err, res) => {
      if (!err) {
        this.setState(prevState => {
          let { formVasarloiKartyaByAidOrSid } = prevState;
          if (res[0].length == 1)
            formVasarloiKartyaByAidOrSid[helyId] = res[0][0];
          else
            formVasarloiKartyaByAidOrSid[helyId] = null;
          return { formVasarloiKartyaByAidOrSid }
        }, () => {
          this.handleVasarloiKartyaChange(this.state.formVasarloiKartyaByAidOrSid[helyId]?.id, item, index);
        });
      }
    });
  }

  getKedvezmeny = (tid, did) => {
    this.setState({ kedvezmenyButtonLoading: true });
    Services.getDiscounts(tid, did, this.state.event.eid, this.state.isRendeles, (err, res) => {
      if (!err) {
        this.setState({ kedvezmenyButtonLoading: false });
        if (res[0].length < 1) {
          this.props.globals.addWarning('A kiválasztott azonosítóhoz nem érvényesíthető kedvezmény!');
        } else {
          this.setState({
            kedvezmenyList: res[0]
          })
        }
      } else {
        this.setState({ kedvezmenyButtonLoading: false });
      }
    });
  }

  getCorrectPrice = (price, kedvezmeny, tid) => {
    if (kedvezmeny) {
      if (kedvezmeny.osszeg) {
        let discountPrice = price - kedvezmeny.osszeg;
        return discountPrice < this.getFixarByTicketTypeId(tid) ? this.getFixarByTicketTypeId(tid) : discountPrice;
      }
      if (kedvezmeny.szazalek) {
        let priceWithoutFix = price - this.getFixarByTicketTypeId(tid);
        let discountPrice = price - (priceWithoutFix * (kedvezmeny.szazalek / 100));
        return discountPrice < this.getFixarByTicketTypeId(tid) ? this.getFixarByTicketTypeId(tid) : discountPrice;
      }
    } else {
      return price;
    }
  }

  submitKedvezmeny = (event, did, aid, sid, ttid) => {
    event.preventDefault();
    this.setState({
      currentDiscountId: did,
      currentAreaId: aid,
      currentSeatId: sid
    }, () => {
      this.getKedvezmeny(ttid, did);
    });
  }

  goBack = () => {
    this.setState({ ron: null, aktivRendelesAreaIds: [], aktivRendelesSeatIds: [] });
    this.props.dismissPortal()
    this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
  }

  hasErvenyesitettJegy = () => {
    let result = false;
    let aktivCopy = JSON.parse(JSON.stringify(this.state.aktivRendeles));

    if (aktivCopy && aktivCopy.jegyadatok) {
      aktivCopy.jegyadatok.forEach(jegy => {
       if (jegy.jegyAllapot === "Érvényesített") result = true;
      });
    }
    return result;
  }

  render() {
    const {
      bucket,
      virtualBucket,
      event,
      layout,
      init,
      formVasarloiKartyaByAidOrSid,
      formKedvezmenyListByJegyTipus,
      formKedvezmenyValueBySid,
      aktivRendeles,
     } = this.state;

    let isVasarlas = this.state.isOsszegzesNezet && !this.state.isRendeles;
    let visszaGombProps = isVasarlas && {
      color: 'danger',
      className: 'table-new-button',
      style:{ backgroundColor: '#f86c6b', border: 'none' }
    };

    let visszaGomb = <React.Fragment>
      <Button
        disabled={this.state.visszatorlesButtonLoading}
        {...visszaGombProps}
        onClick={() => {
          document.body.classList.remove("sidebar-hidden");
          this.state.isOsszegzesNezet && !this.state.isRendeles && !this.state.aktivRendeles ? (
            this.setState({
              visszatorlesButtonLoading: true
            }, () => {
              Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, true, (err, res) => {
                if (!err) {
                  this.setState({ visszatorlesButtonLoading: false }, () => {
                    this.goBack();
                  });
                } else {
                  this.setState({ visszatorlesButtonLoading: false });
                }
              })
            })
          ) : (
            Services.wsSend('/kulsomonitor',this.state.eszkozazonosito, (err, res) => {
              if (!err) {
                if (this.state.event.rid) {
                  Services.orderBack(this.state.event.rid, this.state.ros, this.state.eszkozazonosito, (err) => {
                    if (!err) {
                      this.goBack();
                    } else {
                      this.setState({ visszatorlesButtonLoading: false });
                    }
                  });
                } else {
                  this.goBack();
                }
              }
            })
          );
        }}
      >
        {this.state.isOsszegzesNezet && !this.state.isRendeles && !this.state.aktivRendeles ? 'Rendelés törlése' : 'Vissza'}
      </Button>
    </React.Fragment>;

    return (
      <div>
        <div className="animated fadeIn">
          <div className="row" style={{ padding: 10 }}>
            <div className="col-md-12 col-lg-8" style={{ marginBottom: 10 }}>
              {!this.state.isOsszegzesNezet && visszaGomb}
              <div>
                <span style={{ fontWeight: 800 , color: '#8a71cc', fontSize: '1.75rem', marginBottom: '.6em'}}>
                  {'Helyszín: '}
                  <span style={{ color: '#212529'}}>
                    {this.emptyFormatter(layout.vna)}
                  </span>
                </span>
              </div>
              <span style={{ fontWeight: 600 , color: '#212529', fontSize: '1.5rem', marginBottom: '.6em'}}>
                {this.emptyFormatter(event.nam) + ' | ' +  (event.sta ? TimeFormatter.formatLLLL(event.sta) : '-') + ' | ' + this.emptyFormatter(layout.hna) + (event.pub ? ' ' : ' | ')}
                {(event.pub ? '' : <i className="fa fa-lock" aria-hidden="true" style={{ color: 'red' }} />)}
                </span>
              {' '}
            </div>
            {this.state.isOsszegzesNezet &&
              <div className='col-md-12 col-lg-4' style={{ textAlign: 'right' }}>
                <span style={{ fontWeight: 600 , color: '#212529', fontSize: '1.5rem', marginBottom: '.6em' }}>
                  Rendelésszám: {this.emptyFormatter(this.state.ron)}
                </span>
              </div>
            }
            {this.state.isOsszegzesNezet ? (
              <React.Fragment>
                <iframe name="pdf-area-helyszin" id="pdf-area-helyszin" src={this.state.fileURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
                <div className="col-md-12 col-lg-12" style={{ marginTop: 20, marginBottom: 20 }}>
                  <h4>Személyes adatok megadása:</h4>
                  <RFForm onSubmit={() => {}} style={{ marginLeft: 8 }}>
                    <div className="row">
                      <div className="col-md-2 col-lg-2">
                          {/* Akkor lesz letiltva a mező, ha bármelyik kiválasztott kedvezmény személyhez van kötve (van alanyId) */}
                          <RFField label="Név:" name="formNev" id="formNev" autoComplete="off" forcedValue={this.state.formNev} disabled={Object.values(this.state.formAlanyMap).some(alanyId => !!alanyId)} onChange={this.handleInputChange} />
                      </div>
                      <div className="col-md-2 col-lg-2">
                          <RFField label="E-mail:" name="formEmail" id="formEmail" autoComplete="off" value={this.state.formEmail} onChange={this.handleInputChange} />
                      </div>
                      <div className="col-md-2 col-lg-2">
                          <RFField label="Bizonylatszám:" name="formBizonylatszam" id="formBizonylatszam" autoComplete="off" value={this.state.formBizonylatszam} onChange={this.handleInputChange} />
                      </div>
                      <div className="col-md-6 col-lg-6">
                          <RFField label="Megjegyzés:" name="formMegjegyzes" id="formMegjegyzes" value={this.state.formMegjegyzes} onChange={this.handleInputChange} />
                      </div>
                    </div>
                  </RFForm>
                </div>
                <RFForm onSubmit={() => {}}>
                  {virtualBucket.map((item, index) => {
                    return (
                      <React.Fragment>
                        <div className='col-md-12 col-lg-12 row' style={{ display: index != 0 ? 'none' : ''}}>
                          <div className="col-md-2 col-lg-2" style={{ marginBottom: 20 }}>
                            <h4>Hely:</h4>
                          </div>
                          <div className='col-md-8 row'>
                            <div className='col-md-4 col-lg-4'>
                              <h4>Jegytípus módosítás:</h4>
                            </div>
                            <div className='col-md-3 col-lg-3' style={{ paddingLeft: 15}}>
                              <h4>Kártya sorszám:</h4>
                            </div>
                            <div className='col-md-5 col-lg-5' style={{ paddingLeft: 30 }}>
                              <h4>Kedvezmény:</h4>
                            </div>
                          </div>
                          <div className="col-md-2 col-lg-2" style={{ paddingLeft: 50 }}>
                            <h4 style={{whiteSpace:'nowrap'}}>Fizetendő érték:</h4>
                          </div>
                        </div>
                        <div className="row" style={{ paddingLeft: '15px', marginBottom: 6 }}>
                          <div className="col-md-2">
                            {/* HELY: */}
                            <div style={{ padding: 15, border: '1px solid #e4e4e4', marginBottom: 6 }}>
                              <span>{' ' + (item.sid ? item.secnam + ', ' : '') + (item.lbp ? item.lbp : ' ') + ' ' + (item.rowLabel ? item.rowLabel + ', ' : ' ') + (item.lsp ? item.lsp : ' ') + ' ' + (item.lab || ' ') + (item.lss ? item.lss : ' ') }</span>
                            </div>
                          </div>
                          <div className='col-md-8 row align-items-center'>
                            {/* JEGYTÍPUS MÓDOSÍTÁS: */}
                            <div className="col-md-4">
                              <Input type="select" name="select" id="exampleSelect" value={item.ttid} onChange={(e) => this.handleJegytipusChange(e, item, index)} style={{ height: '52.6px' }}>
                                {this.getTicketTypesBySector(item.tid)}
                              </Input>
                            </div>
                            {/* KÁRTYA SORSZÁM: */}
                            <div className="col-md-3">
                              {item.dis &&
                                <RFField
                                  name={"formVasarloiKartya"+index}
                                  id={"formVasarloiKartya"+index}
                                  onChange={_.debounce((e, v) => this.loadVasarloiKartyaOptions(v, item, index), 500)}
                                  forcedValue={this.state.formVasarloiKartyaByAidOrSid[this.getCompoundId(item.aid, item.sid, index)]?.azonosito}
                                  style={{ height: '52.6px', fontSize: '1rem' }}
                                  hideFormGroup
                                  autoComplete="off"
                                />
                            }
                            </div>
                            {/* KEDVEZMÉNY: */}
                            <div className="col-md-5">
                              <form onSubmit={(e) => this.submitKedvezmeny(e, item.did, item.aid, item.sid, item.ttid)}>
                                {item.dis && (
                                  <React.Fragment>
                                    <Input
                                      type="select"
                                      name={"select"+index}
                                      id={"exampleSelect"+index}
                                      disabled={!item || !formKedvezmenyListByJegyTipus[this.getCompoundId(item.aid, item.sid, index)] ||
                                        !formKedvezmenyListByJegyTipus[this.getCompoundId(item.aid, item.sid, index)][item.idn] || formKedvezmenyListByJegyTipus[this.getCompoundId(item.aid, item.sid, index)][item.idn].length == 0
                                      }
                                      onChange={(e) => this.handleKedvezmenyChange(e.target.value, item, index)} style={{ height: '52.6px' }}
                                      value={formKedvezmenyValueBySid[this.getCompoundId(item.aid, item.sid, index)]}
                                    >
                                      <option value=''>Válassz kedvezményt...</option>
                                      {this.getKedvezmenyByJegytipus(item.idn, this.getCompoundId(item.aid, item.sid, index))}
                                    </Input>
                                  </React.Fragment>
                                )}
                                </form>
                            </div>
                          </div>
                          {/* FIZETENDŐ ÉRTÉK: */}
                          <div className="col-md-2">
                            <div style={{ padding: 15, border: '1px solid #e4e4e4', marginBottom: 6, textAlign: 'right' }}>
                              <span>{NumberFormatter.formatterSpaceOsszegPenznem(this.getCorrectPrice(item.pri * (item.vqua || 1), item.kedvezmeny, item.ttid), null, item.cur)}</span>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                </RFForm>
                <div className="col-md-12 col-lg-12">
                  <p className="pull-right" style={{ fontSize: '1.5rem' }}><b>{'Összesen (' + this.getTotalTicketCount(true) + ' db) fizetendő:'}</b>{' ' +  NumberFormatter.formatterSpaceOsszegPenznem(this.getTotalPrice(true), null, this.state.currency)}</p>
                </div>
                <div className="col-md-12 col-lg-12">
                  <span className="pull-right" style={{ display: "flex" }}>
                    <h4 style={{ position: "relative", top: "30px" }}>Fizetési mód: &nbsp;</h4>
                    {this.renderPaymentCards()}
                  </span>
                </div>
                <div className="col-md-12 col-lg-12 row no-gutters" style={{ marginTop: 16 }}>
                  <div className='col-md-6 col-lg-6'>
                    {visszaGomb}
                  </div>
                  <div className='col-md-6 col-lg-6'>
                    <Button
                      style={{ marginBottom: 8, marginRight: 8 }}
                      color="primary"
                      type="button"
                      disabled={this.state.fizetesNyomtatasNelkulButtonLoading}
                      className="pull-right table-new-button"
                      onClick={(e) => {
                        e.target.blur();

                        this.setState({ fizetesNyomtatasNelkulButtonLoading: true });

                        let bucket = JSON.parse(JSON.stringify(this.state.virtualBucket));

                        const merged = Object.values(
                          bucket.filter(x => x.aid).reduce((acc, item) => {
                            if (item.aid) {
                              const key = this.getCompoundId(item.id, item.aid, item.tid, item.sid, item.ttid);
                              const kedvezmenyObj = item.kedvezmeny && item.kedvezmeny.id ? {
                                tdd: formVasarloiKartyaByAidOrSid[this.getCompoundId(item.aid, item.sid, item.idx)] && formVasarloiKartyaByAidOrSid[this.getCompoundId(item.aid, item.sid, item.idx)].azonosito,
                                tdi: item.kedvezmeny && item.kedvezmeny.id,
                              } : null;
                              if (!acc[key]) {
                                acc[key] = { ...item };
                                acc[key].qua = item.vqua ? parseInt(item.vqua, 10) : 0;
                                if (kedvezmenyObj) {
                                  acc[key].tdi = [kedvezmenyObj];
                                }
                              } else {
                                acc[key].qua += item.vqua ? parseInt(item.vqua, 10) : 0;
                                if (kedvezmenyObj) {
                                  if (!acc[key].tdi) {
                                    acc[key].tdi = [kedvezmenyObj];
                                  } else {
                                    acc[key].tdi.push(kedvezmenyObj)
                                  }
                                }
                              }
                              return acc;
                            }
                          }, {})
                        );

                        const areatickets = merged.map(item => ({
                          rid: item.rid,
                          id: item.id,
                          aid: item.aid,
                          tid: item.ttid,
                          qua: item.qua,
                          tdi: item.tdi,
                        }));

                        const seattickets = bucket.map((bucketItem, index) => {
                          if ( bucketItem.sid) {
                            return {
                              rid: bucketItem.rid,
                              id: bucketItem.id,
                              sid: bucketItem.sid,
                              tid: bucketItem.ttid,
                              tdd: formVasarloiKartyaByAidOrSid[this.getCompoundId(bucketItem.aid, bucketItem.sid, index)] && formVasarloiKartyaByAidOrSid[this.getCompoundId(bucketItem.aid, bucketItem.sid, index)].azonosito,
                              tdi: bucketItem.kedvezmeny && bucketItem.kedvezmeny.id,
                            };
                          }
                        }).filter(x => !!x);

                        window.removeEventListener("beforeunload", (e) => this.deleteOrder(e), false);
                        window.removeEventListener("popstate", (e) => this.deleteOrder(e), false);

                        const { globals, rendelesId } = this.props;
                        const { route } = globals;
                        if (rendelesId) {
                          Services.sendAdminPurchasePay({
                            ste: 2,
                            rid: this.state.event.rid,
                            eid: this.state.event.eid,
                            now: this.state.init.now,
                            rot: this.state.rot.name,
                            nam: this.state.formNev,
                            pty: this.state.formFizetesiMod,
                            ema: this.state.formEmail,
                            rno: this.state.formBizonylatszam,
                            not: this.state.formMegjegyzes,
                            areatickets: areatickets,
                            seattickets: seattickets,
                            fizmodok: CONSTANTS.fizetesiModAzonositok,
                          }, false, this.state.eszkozazonosito, (err) => {
                            if (!err) {
                            this.props.dismissPortal()
                            document.body.classList.remove("sidebar-hidden");
                            this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
                              this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                            } else {
                              this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                            }
                          });
                        } else {
                          Services.sendAdminPurchase({
                            ste: 2,
                            rid: this.state.event.rid,
                            eid: this.state.event.eid,
                            now: this.state.init.now,
                            rot: this.state.rot.name,
                            nam: this.state.formNev,
                            pty: this.state.formFizetesiMod,
                            ema: this.state.formEmail,
                            rno: this.state.formBizonylatszam,
                            not: this.state.formMegjegyzes,
                            areatickets: areatickets,
                            seattickets: seattickets,
                            fizmodok: CONSTANTS.fizetesiModAzonositok,
                        }, false, this.state.eszkozazonosito, (err) => {
                          if (!err) {
                            this.goBack();
                            document.body.classList.remove("sidebar-hidden");
                            this.props.dismissPortal()
                            this.props.globals.route.navigate("/ui/admin/jegyertekesites/helysziniertekesites/");
                            this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                          } else {
                            this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                          }
                        });
                        }
                      }
                    }
                    >
                      {'Fizetés nyomtatás nélkül'}
                    </Button>
                    {' '}
                    <JegyeladasFizetesButton
                      fizetesButtonLoading={this.state.fizetesButtonLoading}
                      bucket={this.state.virtualBucket}
                      event={this.state.event}
                      init={this.state.init}
                      rot={this.state.rot}
                      formNev={this.state.formNev}
                      formFizetesiMod={this.state.formFizetesiMod}
                      formEmail={this.state.formEmail}
                      formBizonylatszam={this.state.formBizonylatszam}
                      formMegjegyzes={this.state.formMegjegyzes}
                      formVasarloiKartyaByAidOrSid={this.state.formVasarloiKartyaByAidOrSid}
                      rendelesId={this.props.rendelesId}
                      eszkozazonosito={this.state.eszkozazonosito}
                      CONSTANTS={CONSTANTS}
                      setFizetesButtonLoading={(loading) => this.setState({ fizetesButtonLoading: loading })}
                      addSuccess={this.props.globals.addSuccess}
                      goBack={this.goBack}
                      getCompoundId={this.getCompoundId}
                    />
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="col-md-6 col-lg-6" style={{ minHeight: 500, whiteSpace: 'pre-line' }}>
                  <SvgViewer
                    withSectorColors
                    zoomEnabled={false}
                    height="650px"
                    onKeyDown={this.onKeyDown}
                    onKeyUp={this.onKeyUp}
                    data={layout}
                    szektorok={init.sectors}
                    szinek={{
                      coa: init.coa,
                      con: init.con,
                      cop: init.cop
                    }}
                    aktivRendelesId={this.state.aktivRendelesId}
                    aktivRendelesAreaIds={this.state.areaIdsInOrder}
                    aktivRendelesSeatIds={this.state.seatIdsInOrder}
                    onSeatClick={this.onSeatClick}
                    onAreaClick={this.onAreaClick}
                  />
                  <div style={{ paddingTop: 20 }}>
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'green', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Szabad'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'black', backgroundColor: 'yellow', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Folyamatban'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'gray', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Foglalt'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'purple', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Barion'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'red', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Fizetett'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: '#2196f3', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                      >
                      {'Érvényesített'}
                    </Button>
                    {' '}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4">
                  {this.state.aktivRendeles && (
                    <React.Fragment>
                      {(this.props.globals.hasRoleSpec(['JEGYVASARLAS_RENDELES_TORLES']) && (!this.hasErvenyesitettJegy())) && (
                        <div className="pull-right">
                          <ProgressButton
                            style={{ color: 'white', backgroundColor: 'red', borderColor: 'transparent', cursor: 'pointer' }}
                            color="secondary"
                            type="button"
                            className="table-new-button"
                            loading={false}
                            onClick={(e) => {
                              e.target.blur();
                              this.handleDeleteClick(this.state.aktivRendelesId);
                            }}
                          >
                            Rendelés törlése
                          </ProgressButton>
                        </div>
                      )}
                      <h4 className='mb-1'>Rendelésszám: {this.emptyFormatter(this.state.ron)}</h4>
                      <ul className='d-flex flex-column' style={{ fontSize: 16, marginBottom: 16 }}>
                        <li>Név: <b>{this.state.aktivRendeles.rendeloNev}</b></li>
                        <li>E-mail: <b>{this.state.aktivRendeles.rendeloEmail}</b></li>
                      </ul>
                    </React.Fragment>
                  )}
                  {!this.state.isOsszegzesNezet && this.state.currency && this.getTotalTicketCount() > 0 && (
                    <div style={{ fontWeight: 500 , color: '#212529', fontSize: '1.4rem', marginBottom: '.6em'}}>
                      {' Jegyek összesen: ' + this.getTotalTicketCount() + ' db / ' + NumberFormatter.formatterSpaceOsszegPenznem(this.getTotalPrice(), null, this.state.currency)}
                    </div>
                    )}
                  <h4>
                    Jegyek:
                  </h4>
                  {this.state.aktivRendelesLoading ? <Loader /> : !this.state.aktivRendeles && this.state.bucket.length < 1 ? <EmptyState title="" hasImage /> : this.renderBucket()}
                </div>
                <div className="col-md-2 col-lg-2">
                  <h4>
                    Jegytípus:
                  </h4>
                  <div style={{ minHeight: 300 }}>
                    {this.hasSelectedTicket() ? (
                      <div style={{ marginTop: 30 }}>
                        {this.renderJegytipusok()}
                      </div>
                    ) : (
                      <EmptyTypes hasImage />
                    )}
                  </div>
                  <br />
                  {(this.state.aktivRendeles) ? (
                    (this.state.aktivRendeles.rendelesAllapot === "Lefoglalt" || this.state.aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)") && (
                      <ProgressButton
                      style={{ marginBottom: 8, marginRight: 8 }}
                      color="primary"
                      type="button"
                      className="pull-left table-new-button"
                      loading={this.state.foglalasButtonLoading}
                      onClick={(e) => {
                        e.target.blur();
                        this.handlePurchaseFoglalas()
                      }}
                      >
                      Vásárlás
                    </ProgressButton>
                    )
                  ) : (
                    <React.Fragment>
                      {this.state.init.rot.map((item, idx) => {
                        return (
                          <ProgressButton
                            key={idx}
                            style={{ marginBottom: 8, marginRight: 8 }}
                            color="primary"
                            type="button"
                            className="pull-left table-new-button"
                            loading={this.state.buttonLoading}
                            onClick={(e) => {
                              e.target.blur();
                              this.handleSubmitType(item.name);
                            }}
                          >
                            {item.publiccaption}
                          </ProgressButton>
                        );
                      })}
                    </React.Fragment>
                  )}
                </div>
              </React.Fragment>
            )}
            <div className="col-md-12 col-lg-12" style={{ paddingTop: 20 }} />
          </div>
        </div>
        <React.Fragment>
          <Modal isOpen={this.state.isFoglalasModalOpen} toggle={this.toggleFoglalasModal} className={this.props.className} backdrop="static">
          <RFForm
            onSubmit={() => {}}
            modal
            title={'Foglalás'}
            footer={
              <React.Fragment>
                <ProgressButton
                  style={{ marginBottom: 8, marginRight: 8 }}
                  color="primary"
                  type="submit"
                  className="pull-left table-new-button"
                  loading={this.state.foglalasButtonLoading}
                  onClick={(e) => {
                    e.target.blur();
                    this.onFoglalasVeglegesites();
                  }}
                >
                  {'Véglegesítés'}
                </ProgressButton>
                <ProgressButton
                  style={{ marginBottom: 8, marginRight: 8 }}
                  color="secondary"
                  type="button"
                  className="pull-left table-new-button"
                  loading={this.state.foglalasButtonLoading}
                  onClick={(e) => {
                    e.target.blur();
                    this.setState({
                      foglalasButtonLoading: true
                    }, () => {
                      Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, false, (err, res) => {
                        if (!err) {
                          let eventNullRid = JSON.parse(JSON.stringify(this.state.event));
                          eventNullRid.rid = null;
                          this.toggleFoglalasModal();
                          this.setState({ foglalasButtonLoading: false, ron: null, event: eventNullRid });
                        } else {
                          this.setState({ foglalasButtonLoading: false });
                        }
                      });
                    });
                  }}
                >
                  {'Mégsem'}
                </ProgressButton>
              </React.Fragment>
            }
          >
            <p style={{ fontSize: '1.65rem' }}>Személyes adatok megadása:</p>
            <RFField label={'Név: *'} name="formNev" value={this.state.formNev} onChange={this.handleInputChange} required />
            <RFField label={'E-mail: *'} name="formEmail" value={this.state.formEmail} onChange={this.handleInputChange} required />
            <RFField label={'Bizonylatszám:'} name="formBizonylatszam" value={this.state.formBizonylatszam} onChange={this.handleInputChange} />
            <RFField label={'Megjegyzés:'} name="formMegjegyzes" type="textarea" value={this.state.formMegjegyzes} onChange={this.handleInputChange} />
            <p>* = A mezők kitöltése kötelező</p>
          </RFForm>
          </Modal>
        </React.Fragment>

        <RFForm
          onSubmit={this.deleteRendeles}
          modalInsert
          title={'Törlés'}
          tagProps={{ isOpen: this.state.modalDelete, toggle: this.toggleDeleteModal, backdrop: 'static' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.deleteRendeles()}
                loading={this.state.deleteButtonLoading}
              >
                {'Törlés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott rendelést?</div>
          {this.state.hasTorlesOka && (
            <RFField label={'Törlés oka: *'} name="formTorlesOka" id="formTorlesOka" required value={this.state.formTorlesOka} onChange={this.handleInputChange} />
          )}
        </RFForm>
      </div>
    );
  }
}

JegyeladasContent.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default JegyeladasContent;
